import { FormattedMessage } from 'react-intl';
import messages from 'src/apps/ai-leadership-assistant/locales/messages';

export default {
  mainHeader: {
    title: <FormattedMessage {...messages.headerTitle} />,
    description: <FormattedMessage {...messages.headerDescription} />,
  },
};
